// extracted by mini-css-extract-plugin
module.exports = {"container":"PublicFooter_container__3O5fO"};